export const appointmentTypeMapping = {
  "meter-investigation": "FAULTS",
  "meter-reboot": "FAULTS",
  "meter-power-cycle": "FAULTS",
  "recommission-dual": "COMMISSION_JOIN",
  "recommission-elec": "COMMISSION_JOIN",
  "recommission-gas": "COMMISSION_JOIN",
  "meter-exchange-dual": "METER_EXCHANGE",
  "meter-exchange-elec": "METER_EXCHANGE",
  "meter-exchange-gas": "METER_EXCHANGE",
  install: "METER_EXCHANGE",
  "install-elec": "METER_EXCHANGE",
  "install-gas": "METER_EXCHANGE",
} as const

export const InstallEligibilityReasons = {
  ELIGIBLE_ELEC_EXCHANGE: "ELIGIBLE_ELEC_EXCHANGE",
  ELIGIBLE_GAS_EXCHANGE: "ELIGIBLE_GAS_EXCHANGE",
  ELIGIBLE_DUAL_EXCHANGE: "ELIGIBLE_DUAL_EXCHANGE",
  INELIGIBLE_ALREADY_SMART: "INELIGIBLE_ALREADY_SMART",
  INELIGIBLE_SWITCHING_AWAY: "INELIGIBLE_SWITCHING_AWAY",
  INELIGIBLE_TOO_COMPLEX: "INELIGIBLE_TOO_COMPLEX",
  INELIGIBLE_MOP_DISCREPANCY: "INELIGIBLE_MOP_DISCREPANCY",
} as const

export const CancellationReason = {
  MED_APPT: "MED_APPT",
  SLOT_INCONVENIENT: "SLOT_INCONVENIENT",
  NOT_INTERESTED: "NOT_INTERESTED",
  PRIVACY_CONCERNS: "PRIVACY_CONCERNS",
  DO_NOT_POWER_OFF: "DO_NOT_POWER_OFF",
  LANDLORD_OBJECTS: "LANDLORD_OBJECTS",
  CHILD_CARE: "CHILD_CARE",
  NO_ACCESS: "NO_ACCESS",
} as const

export const CANCELLATION_REASON_LABELS: Record<string, string> = {
  [CancellationReason.MED_APPT]: "I have a medical appointment",
  [CancellationReason.SLOT_INCONVENIENT]:
    "The appointment time is inconvenient",
  [CancellationReason.NOT_INTERESTED]: "I'm no longer interested",
  [CancellationReason.PRIVACY_CONCERNS]: "I have privacy / data concerns",
  [CancellationReason.DO_NOT_POWER_OFF]:
    "I don't want the power to be turned off",
  [CancellationReason.LANDLORD_OBJECTS]: "My landlord objects",
  [CancellationReason.CHILD_CARE]: "I have childcare responsibilities",
  [CancellationReason.NO_ACCESS]: "It is difficult to access the meter(s)",
}

export const RESCHEDULE_REASONS = [
  CancellationReason.MED_APPT,
  CancellationReason.SLOT_INCONVENIENT,
  CancellationReason.CHILD_CARE,
] as const

export const MeterReadingFrequency = {
  HALF_HOURLY: "HALF_HOURLY",
  DAILY: "DAILY",
  MONTHLY: "MONTHLY",
} as const
